// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AdressvorschlagPayload,
  CALLER_ID,
  CoordinatesChangedPayload,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import {
  App,
  Auslandsrisikoort,
  Immobilie,
  PlzChanged,
  Risikoort,
  VwgVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export const risikoortReducer = function (
  sectionState: Auslandsrisikoort = null,
  action: AnyAction,
  appState: IAppState,
): Auslandsrisikoort {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      if (action.payload.appId !== App.VWG || action.payload.angebotsId !== appState.angebotsId) {
        return sectionState;
      }
      const risikoort: Risikoort = (action.payload.immobilie as Immobilie).risikoort;
      if (risikoort) {
        return {
          ...sectionState,
          plz: risikoort.plz,
          ort: risikoort.ort,
          strasse: risikoort.strasse,
          hausnummer: risikoort.hausnummer,
          hausnrzus: risikoort.hausnrzus,
        };
      }
      return sectionState;
    }
    case VwgActions.PLZ_CHANGED: {
      const actionPayload: PlzChanged = action.payload;
      const geoCoordindatesSelected =
        sectionState.latitude != null && sectionState.longtitude != null;
      return {
        ...sectionState,
        plz: actionPayload.plz,
        ort: '',
        strasse: geoCoordindatesSelected ? sectionState.strasse : '',
        hausnummer: geoCoordindatesSelected ? sectionState.hausnummer : '',
        noneValidated: geoCoordindatesSelected,
      };
    }
    case VwgActions.RESET_ADRESSDATEN: {
      return {
        plz: '',
        ort: '',
        strasse: '',
        hausnummer: '',
        land: {
          wert: '',
          text: '',
        },
        ortsteil: '',
        hausnrzus: '',
        status: null,
        latitude: null,
        longtitude: null,
        auslandsrisiko: null,
      };
    }
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      const angebotsId = appState.angebotsId;
      const callerId = `${CALLER_ID.VWG_BASISDATEN}_${angebotsId}`;
      if (payload.callerId !== callerId) {
        return sectionState;
      }
      if (payload.orte?.length === 1) {
        return {
          ...sectionState,
          ort: payload.orte[0],
        };
      }
      return sectionState;
    }
    case VwgActions.ORT_CHANGED: {
      return {
        ...sectionState,
        ort: action.payload.ort,
      };
    }
    case VwgActions.STRASSE_CHANGED: {
      return {
        ...sectionState,
        strasse: action.payload.strasse,
      };
    }
    case VwgActions.HAUSNUMMER_CHANGED: {
      return {
        ...sectionState,
        hausnummer: action.payload.hausnummer,
      };
    }
    case VwgActions.LAND_CHANGED: {
      return { ...sectionState, land: action.payload.land };
    }
    case VwgActions.ORTSTEIL_CHANGED: {
      return { ...sectionState, ortsteil: action.payload.ortsteil };
    }
    case VwgActions.HAUSNRZUS_CHANGED: {
      return { ...sectionState, hausnrzus: action.payload.hausnrzus };
    }
    case VwgActions.MAP_COORDINATES_VWG_CHANGED_EINGABE:
    case VwgActions.MAP_COORDINATES_VWG_CHANGED_ANGEBOT: {
      const actionPayload: CoordinatesChangedPayload = action.payload;
      if (actionPayload?.appId === App.VWG && actionPayload?.angebotsId === appState.angebotsId) {
        return {
          ...sectionState,
          latitude: actionPayload.coordinates.lat,
          longtitude: actionPayload.coordinates.lon,
          noneValidated: true,
        };
      } else {
        return sectionState;
      }
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VwgVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VWG && actionPayload.angebotsId === appState.angebotsId) {
        return {
          ...sectionState,
          plz: actionPayload.risikoort?.plz,
          strasse: actionPayload.risikoort?.strasse,
          hausnummer: actionPayload.risikoort?.hausnummer,
          ort: actionPayload.risikoort?.ort,
        };
      }
      return sectionState;
    }
    case VwgActions.AUSLAENDISCHE_ADRESSE_CHANGED: {
      return {
        ...sectionState,
        isImmobilieImAusland: action.payload,
      };
    }
    case GlobalActions.UPDATE_RISIKOORT_ZUERSZONE: {
      if (action.payload.angebotsId === appState.angebotsId) {
        return {
          ...sectionState,
          zuerszone: action.payload.zuerszone,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
